export default __webpack_public_path__ + "static/media/unhcrimage.71f51b9a.jpg";